export const numberOnly = (value: string) => {
  return value.replace(/[^0-9]/g, '');
};

export const phoneOnly = (value: string) => {
  return value.replace(/[^0-9()-/]/g, '');
};

export const razonSocial = (value: string) => {
  return value.replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ\- @.&!]/g, '');
};

export const addressOnly = (value: string) => {
  return value.replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ.\-_, ]/g, '');
};

export const letterAndNumber = (value: string) => {
  return value.replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ ]/g, '');
};

export const upperCaseAndNumber = (value: string) => {
  return value.toUpperCase().replace(/[^a-zA-Z0-9ñÑáéíóúÁÉÍÓÚ ]/g, '');
};

export const letterOnly = (value: string) => {
  return value.replace(/[^a-zA-ZñÑáéíóúÁÉÍÓÚ ]/g, '');
};

export const promoOnly = (value: string) => {
  return value.toUpperCase().replace(/[^A-Z0-9ÑÁÉÍÓÚ ]/g, '');
};

export const documentAltOnly = (value: string) => {
  return value.toUpperCase().replace(/[^A-Z0-9 ]/g, '');
};

export const serieOnly = (value: string) => {
  return value.replace(/[^a-zA-Z0-9-]/g, '');
};

export const decimalOnly = (value: string) => {
  return value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
};

export const numberWithCommas = (value: string) => {
  return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const noSpace = (value: string) => {
  return value.replace(/ /g, '');
};
